<template>
  <div id="service0">
    <Header/>
    <section class="banner">
      <img class="banner_bg" src="@/assets/zhengxin/banner1.jpg" alt="banner">
      <p class="banner_text"  >
        <img src="@/assets/zhengxin/banner-text.png" alt="banner-text">
        <button class="banner_btn"  @click="showContact('文案编制与咨询培训服务',0)">一键获取服务</button >
      </p>
    </section>
    <section class="section1">
      <div class="container">
        <h3 class="title">业务经验</h3>
        <p class="subtitle">团队多年来致力于信用研究与咨询培训，汇聚知名专家学者，坚持前沿理论与先进实践相结合，重点开展信用理论方法研究、政策研究、实践路径研究、创新应用探索等，深耕行业多年。近五年来，已为10余个国家部委、30余个地方政府、10余个大型国企和头部互联网公司提供上百项信用研究与咨询服务。
        </p>
        <ul class="flex flex_around">
          <li><img src="@/assets/zhengxin/21.png" alt="">年行业深耕</li>
          <li><img src="@/assets/zhengxin/110.png" alt="">项目实践经验</li>
          <li><img src="@/assets/zhengxin/20.png" alt="">知名专家顾问</li>
        </ul>
      </div>
    </section>

    <section class="section2">
      <div class="container">
        <h3 class="title">服务项目</h3>
        <p class="subtitle">六大产品与服务可组合可单点，全方位助力您的信用工作。</p>
        <ul class="service_wrap flex flex_wrap">
          <li class="service_item" v-for="item in serviceList" :key="item.id" :id="'service'+item.id">
            <div class="service_item_bg"  :class="{'float_change':item.float}">
              <div class="service_item_img">
                <img :src="require('@/assets/zhengxin/objecBg'+item.id+'.png')" alt="项目">
                <p v-html="item.title"></p>
              </div>
              <div class="service_item_text">
                <p v-for="text in item.content" v-html="text"></p>
                <button @click="showContact(item.title,item.id)">获取服务</button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="section3">
      <div class="container">
        <h3 class="title">成果风采</h3>
        <p class="subtitle">深耕行业多年，渐有丰硕成果，全心全意做您信用工作的贴心支持者。</p>
        <ul class="chengguo flex flex_between">
          <li class="chengguo_item" v-for="item in chengguo">
            <img :src="require('@/assets/zhengxin/bg'+item.id+'.jpg')" alt="成果">
            <p class="chengguo_item_title" v-html="item.title"></p>
            <div class="hide flex flex_column flex_between">
              <h6>{{ item.subtitle }}</h6>
              <p v-html="item.text"></p>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="section5">
      <div class="container">
        <p class="title">一站获取您的专属信用专家与服务</p>
        <Contact />
      </div>
    </section>
    <UserNeed ref="userNeed"/>
  </div>
</template>

<script>
import Contact from "@/components/Contact";
import UserNeed from "@/components/UserNeed";

export default {
  name: "ZhengXinFu",
  components: {
    Contact,UserNeed
  },
  data(){
    return{
      serviceList:[
        {
          id:1,
          title:"信用规划编制",
          content:["对接国家信用规划及政策文件","深入挖掘政府部门和市场需求","兼具战略前瞻性与落地实操性","权威专家全程指导","可提供专家咨询与辅导服务"],
        },
        {
          id:2,
          float:true,
          title:"信用政策文件起草",
          content:["把握最新形势要求和发展脉络","以深度调研、数据分析为支撑","数十个地方信用工作调研经验","征询吸纳多位知名专家意见","可提供专题培训与宣贯服务"],
        },
        {
          id:3,
          float:true,
          title:"权威专家<br>专项咨询辅导",
          content:["15+权威专家、高管辅导团队","线上、线下灵活讲授形式","可按需定制基础知识、专题咨<br>询等多种辅导内容","提供咨询报告等多种成果形式"],
        },
        {
          id:4,
          title:"信用建设<br>创新模式打造",
          content:["从设计到落地一站式解决方案","切合现有基础与各方需求","立足当地实际 显著提升拔高","擅于结合新形势打造特色亮点","协助落地应用及宣传"],
        },
        {
          id:5,
          title:"目录清单式<br>管理机制构建",
          content:["目录式梳理关联信用数据、失 信行为、监管措施等","为平台搭建、精准施策等服务","可实现触发式管理、高级映射<br>型管控等创新机制"],
        },
        {
          id:6,
          float:true,
          title:"信用项目建设<br>方案与路径研究",
          content:["基建、能源等15+行业研究","专注大数据、机器学习、区块 链等新兴技术信用应用","促成某能源行业信用信息服务<br>平台等十余类应用项目"],
        },

      ],
      chengguo:[
        {
          id:3,
          title:"电力许可信用监管<br>制度体系设计",
          subtitle:"电力许可信用监管制度体系设计",
          text:"团队开展电力许可信用监管顶层设计、信用分类等级评定标准、分类监管细化措施" +
               "等课题研究，为电力许可信用监管进行顶层设计，并以三维信用理论为基础，通过" +
               "建立信用档案的更新与应用机制，及信用分类评价信息的维度扩展与结果应用，<span  style='color: #BD1A2D;'>实" +
               "现电力许可事前、事中、事后全流程联动，构建信用监管闭环。</span>项目委托方对顶层" +
               "设计撰写思路的清晰性、落地实用性以及团队专业性给予了充分肯定。"
        },
        {
          id:4,
          title:"某市社会信用体系建设<br>行动方案编制",
          subtitle:"某市社会信用体系建设行动方案编制",
          text:"为某市开展社会信用体系建设三年行动方案编制工作，<span style='color: #BD1A2D;'>在全国首创了“三维联动”" +
               "信用监管模式，</span>创新提出三项重点任务：一是建立<span style='color: #BD1A2D;'>8+X制度体系</span>，主要包括信用监" +
               "管机制、信用交易机制等８种机制构建；二是建立包含信用承诺、信用分类监管、" +
               "信用联合奖惩、信用修复的“三维联动”信用监管模式；三是提供诸如“互联网+" +
               "信用”中介超市等<span style='color: #BD1A2D;'>“三维立体”</span>公共服务。项目成果获得省级创新实践案例通报。"
        }
      ],
      needs:"",
      type:0
    }
  },
  watch:{
    '$route.params.id':function () {
      this.goScroll();
    }
  },
  mounted(){
    this.goScroll();
  },
  methods:{
    goScroll(){
      let id = this.$route.params.id;
      document.getElementById(`service${id}`).scrollIntoView(
        {
          behavior: "smooth",  // 平滑过渡
          block:    "start"  // 上边框与视窗顶部平齐。默认值
        }
      );
    },
    showContact(title,id){
      console.log(title, id);
      this.$refs.userNeed.showModal(title,id);
    }
  }
};
</script>

<style scoped lang="less">
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  .banner{
    position: relative;
    .banner_bg{
      width: 100%;
    }
    .banner_text{
      position: absolute;
      top:70px;
      left: 50%;
      width: 1196px;
      margin-left: -598px;
      img {
        display: block;
        width: 442px;
        margin-bottom: 60px;
      }
      .banner_btn{
        color: #fff;
        font-size: 24px;
        width: 218px;
        height: 55px;
        background: rgba(189, 26, 45, 1);
        text-align: center;
        line-height: 55px;
        &:hover{
          background: rgba(189, 26, 45, .9);
        }
      }
    }
  }
  .title{
    font-size: 34px;
    font-weight: 500;
    color: #000;
    margin-top: 80px;
  }
  .subtitle{
    font-size: 14px;
    color: #919191;
    margin: 12px 0 30px;
    line-height: 1.6;
  }
  .section1{
    .title{
      margin-top: 60px;
    }
    .subtitle{
      font-size: 16px;
      color: #000;
      margin-top: 30px;
    }
    ul{
      vertical-align: bottom;
      li{
        color: #BD1A2D;
        font-size: 26px;
        img{
          height: 53px;
          margin-right: 10px;
        }
      }
    }
  }
  .section2{
    .service_wrap{
      width: calc(100% + 40px);
      margin-left: -20px;
      .service_item{
        width: 50%;
        padding: 20px;
        box-sizing: border-box;
        .service_item_bg{
          background: #F3F3F3;
          box-sizing: border-box;
          overflow: hidden;
          height: 100%;
          .service_item_img{
            float: left;
            position: relative;
            width: 50%;
            img{
              width: 100%;
              display: block;
            }
            p{
              color: #fff;
              font-size: 26px;
              position: absolute;
              top:30px;
              left:24px;
            }
          }
          .service_item_text{
            box-sizing: border-box;
            width: 50%;
            position: relative;
            float: right;
            padding: 20px 26px;
            font-size: 16px;
            line-height: 2;
            height: 100%;
            p{
              position: relative;
              padding-left: 10px;
              &::before{
                content: " ";
                position: absolute;
                left:0;
                top:12px;
                display: block;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: #333;
              }
            }
            button{
              position: absolute;
              left:30px;
              bottom:20px;
              width: 144px;
              height: 46px;
              background: #005293;
              font-size: 20px;
              color: #fff;
              text-align: center;
              line-height: 46px;
              cursor: pointer;
              transition: all ease .3s;
              &:hover{
                background:rgba(0,82,147,.8)
              }
            }
          }
          &.float_change{
            .service_item_img{
              float: right;
              p{
                left: initial;
                right:24px;
                text-align: right;
              }
            }
            .service_item_text{
              float: left;
              button{
                right:30px;
                left:initial;
              }
            }
          }
        }
      }
    }
  }
  .section3{
    margin-bottom: 28px;
    .chengguo{
      .chengguo_item{
        width: calc(50% - 20px);
        position: relative;
        img{
          display: block;
          width: 100%;
        }
        .chengguo_item_title{
          position: absolute;
          font-size: 28px;
          color: #fff;
          top:50%;
          right:40px;
          transform: translate(0,-50%);
          text-align: right;
        }
        &:last-child{
          .chengguo_item_title{
            right:initial;
            left:40px;
            text-align: left;
          }
        }
        .hide{
          position: absolute;
          top:0;
          left:0;
          right:0;
          bottom:0;
          background: #F3F3F3;
          padding: 35px;
          opacity: 0;
          -webkit-transition:all .3s ease;
          transition:all .3s ease;
          h6{
            font-size: 20px;
          }
          p{
            font-size: 14px;
            line-height: 1.6;
            text-align: justify;
          }
        }
      }
      .chengguo_item:hover{
        .hide{
          opacity: 1;
        }
      }
    }
  }
  .section5{
    background: url("../assets/zhengxin/bg5.jpg") 50% 50% no-repeat;
    background-size: cover;
    padding: 45px 0;
    .title{
      text-align: center;
      color: #fff;
      font-size: 32px;
      margin: 0 0 30px;
    }
  }
</style>
